
// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


// Afidium
import { AfidiumServiceFieldComponent } from './afidium-service-field.component';
import { PopupMenuModule } from 'libraries/component/popup-menu/popup-menu.module';
import { DateRangeModule } from 'libraries/module/formbuilder/fields/date-range/date-range.module';
import { ButtonModule } from 'libraries/module/formbuilder/fields/button/button.module';
import { MultiselectModule } from "libraries/module/formbuilder/fields/multiselect/multiselect.module";
import { ViewsModule } from "libraries/view/views.module";
import { ReactiveFormsModule } from '@angular/forms';
import { AfidiumServiceFieldsetService } from "app_sasha/shared/components/afidium-service-field/afidium-service-fieldset.service";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";

@NgModule({
    imports: [
        CommonModule,
        PopupMenuModule,
        DateRangeModule,
        ButtonModule,
        MultiselectModule,
        ViewsModule,
        ReactiveFormsModule,
        FontAwesomeModule,
    ],
    declarations: [
        AfidiumServiceFieldComponent,
    ],
    exports: [
        AfidiumServiceFieldComponent,
    ],
    providers: [
        AfidiumServiceFieldsetService,
    ],
})
export class AfidiumServiceFieldModule { }
